<template>
  <div />
</template>
<script>
// @ is an alias to /src
import { db } from "@/fstore";

export default {
  name: "ShowsBinder",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {},
  mounted() {
    var _v = this;
    // Does document exist.
    // These are the video shows. This will be deprecated soon.
    db.collection("shows")
      .where("user", "==", this.user.uid)
      .orderBy("updated_at", "desc")
      .limit(20)
      .onSnapshot(function(querySnapshot) {
        var shows = [];
        querySnapshot.forEach(function(doc) {
          shows.push(doc.data());
        });
        _v.$store.commit("set_shows", shows);
      });
    /*
    db.collection("editor_shows")
      .where("user", "==", this.user.uid)
      .where("deleted", "==", false)
      .orderBy("updated_at", "desc")
      .limit(10)
      .onSnapshot(function(querySnapshot) {
        var shows = [];
        querySnapshot.forEach(function(doc) {
          shows.push(doc.data());
        });
        _v.$store.commit("set_editor_shows", shows);
      });
      */
  },
  methods: {}
};
</script>
